import React from 'react';
import { Card } from 'antd';

export default function OrderPricingCard(props) {
    const pricing = props.order && props.order.pricing ? props.order.pricing : {};
    const formatMoney = (value) => `${new Intl.NumberFormat('vi-VN').format(value || 0)}đ`;

    return (
        <Card title="Thanh toán">
            <div><strong>Tạm tính:</strong> {formatMoney(pricing.subtotal)}</div>
            <div><strong>Giảm giá:</strong> {formatMoney(pricing.discount)}</div>
            <div><strong>Phí vận chuyển:</strong> {formatMoney(pricing.shipping_fee)}</div>
            <div><strong>Tổng cộng:</strong> {formatMoney(pricing.grand_total)}</div>
        </Card>
    );
}
